import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=34d5cf5a&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
import style0 from "./Edit.vue?vue&type=style&index=0&id=34d5cf5a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d5cf5a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Customers/AdminChiefs/Edit.vue
// module id = 2564
// module chunks = 31